module.exports = __webpack_public_path__ + "static/media/logo_wordmark_black.fe82ff42.png";